//@flow
import * as React from 'react';
import {baseClass} from "../../../../pages/UiKit/newUiKit/utilities/baseClass";
import type {children, id} from "../../../../services/flowTypes/appFlowTypes";
import type {addClasses} from "../../../../services/flowTypes/uiKitFlowTypes";
import './InfoPanelLabel.css';

type Props = {
  id?: id,
  addClasses?: addClasses,
  children: children
};

const InfoPanelLabel = (props: Props) => {
  return (
    <div id={props.id} className={baseClass("InfoPanelLabel", props.addClasses)}>{props.children}</div>
  );
};

export default InfoPanelLabel;